import _ from "underscore";

export default {
  /**
   * Finds the pre-defined validation message for a given form field.
   * @param messages The source list of messages to look through.
   * @param ref The identifier of a message in the source. Does not necessarily tie to any attributes in a HTML element.
   * @returns {*|string}
   */
  getFieldValidationMessage(messages, ref, code=undefined) {
    const field = code
      ? _.find(messages, item => (item.ref === ref && item.code === code))
      : _.find(messages, item => item.ref === ref);
    return field ? field.message : '';
  },

  getFieldAccessibleDescription(messages, ref) {
    const list = _.filter(messages, item => item.ref === ref);

    // console.log(list)

    let desc = '';
    if (list && list.length > 0) {
      _.each(list, item => {
         desc = `${desc}${item.message} `
       });
    }

    return desc;
  }
}
